import {
  Injectable
} from '@angular/core';

import {
  CanActivate,
  CanLoad,
  Route,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  UrlSegment,
  UrlTree
} from '@angular/router';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserProfileService } from '../services/user.service';


@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanLoad {

  constructor(
    private router: Router,
    private usuarioService: UserProfileService
  ) {}

  canLoad(
    route: Route,
    segments: UrlSegment[]
  ): Observable<boolean | UrlTree> {
    return this.usuarioService.validarToken().pipe(
      map(estaAutenticado => {
        return estaAutenticado
          ? true
          : this.router.createUrlTree(['/account/login']);
      })
    );
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.usuarioService.validarToken().pipe(
      map(estaAutenticado => {
        return estaAutenticado
          ? true
          : this.router.createUrlTree(['/account/login']);
      })
    );
  }
}